import { format } from "date-fns";
import { FaUserDoctor, FaUserNurse, FaUserTie } from "react-icons/fa6";
import { motion } from "framer-motion";

const shadowTailWind = "shadow-[0px_0px_4px_0px_#00000024]";

const ListAppointmentItem = (props) => {
  const { event, backgroundColor, textColor, onClick, itemTemplate } = props;
  const data = event.data;

  const isPast = event.date < new Date().setHours(0, 0, 0, 0);
  // const animate = !event.data.confirmation_bc_date ? true : false;
  // const stale = !event.data.confirmation_bc_date ? true : false;

  let showPengguna = data.data_pemakai.id !== data.data_supir.id;

  if (itemTemplate) {
    return itemTemplate({
      event,
      backgroundColor,
      textColor,
      onClick,
      itemTemplate,
    });
  } else
    return (
      <div
        // <motion.div
        className={`row-start-start ${
          isPast ? " bg-slate-100 " : shadowTailWind
        } w-full gap-2 cursor-pointer active:translate-y-0.5 active:bg-slate-50 !items-stretch `}
        // animate={
        //   animate
        //     ? {
        //         rotate: [0, -2, 2, 0],
        //         translateY: [0, -2, 0, 0],
        //       }
        //     : undefined
        // }
        // transition={
        //   animate
        //     ? {
        //         duration: 1,
        //         ease: "easeInOut",
        //         times: [0, 0.33, 0.677, 1],
        //         repeat: Infinity,
        //         repeatDelay: 0,
        //       }
        //     : undefined
        // }
        onClick={() => {
          if (onClick) onClick(event);
        }}
      >
        <div
          className={` w-[3px] ${isPast ? "bg-slate-300" : backgroundColor}`}
        />
        <div className={`col-center-start py-1 w-full gap-1`}>
          {data.data_supir && <span> {data.data_supir.nama} </span>}

          <span className="italic text-sm text-slate-400 font-semibold">
            {data.tanggal_perkiraan_berangkat
              ? format(
                  new Date(data.tanggal_perkiraan_berangkat),
                  "dd/MM/yyyy HH:mm"
                )
              : "-"}
          </span>

          {data.data_kendaraan && (
            <div className={`col-start-start`}>
              <span
                className={`text-sm ${
                  isPast ? "text-slate-400" : textColor
                } font-semibold`}
              >
                {data.data_kendaraan.jenis_mobil}
              </span>
              <span
                className={`text-sm ${
                  isPast ? "text-slate-400" : textColor
                } font-semibold`}
              >
                {data.data_kendaraan.nomor_polisi}
              </span>
            </div>
          )}

          {data.data_pemakai && (
            <div className={`col-start-start text-sm`}>
              {`${showPengguna ? data.data_pemakai.nama : ""} (${
                data.jumlah_orang
              } orang)`}
            </div>
          )}

          <div className={`col-start-start`}>
            {data.perkiraan_berangkat && (
              <span className="text-sm text-slate-400">
                {format(new Date(data.perkiraan_berangkat), "hh:mm aa")}
              </span>
            )}
            {data.edit_by && (
              <span className="text-xs text-slate-400">
                {`Last edited by ${data.edit_by}`}{" "}
              </span>
            )}
          </div>

          {data.keterangan && (
            <div className={`col-start-start text-sm`}>
              {`${data.keterangan}`}
            </div>
          )}
        </div>
        {/* </motion.div> */}
      </div>
    );
};

export default ListAppointmentItem;
